import { render, staticRenderFns } from "./TagManage.vue?vue&type=template&id=33827b77&scoped=true&"
import script from "./TagManage.vue?vue&type=script&lang=js&"
export * from "./TagManage.vue?vue&type=script&lang=js&"
import style0 from "./TagManage.vue?vue&type=style&index=0&id=33827b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33827b77",
  null
  
)

export default component.exports